import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import MasonryGallery from "../components/MasonryGallery";

const imagesPage3 = [
      require("../assets/img/gallery/Image-6.jpg"),
      require("../assets/img/gallery/Image-7.jpg"),
      require("../assets/img/gallery/Image-8.jpg"),
      require("../assets/img/gallery/Image-9.jpg"),
      require("../assets/img/gallery/Image-10.jpg"),
      require("../assets/img/gallery/Image-11.jpg"),
      require("../assets/img/gallery/Image-12.jpg"),
      require("../assets/img/gallery/Image-8.jpg"),
      require("../assets/img/gallery/Image-9.jpg"),
];


function About() {
    return (
        <div>
        <section className="welcome-message section-padding">
        <Container>
          <Row className="align-items-center ">
            <Col lg={12} sm={12}>
            <MasonryGallery images={imagesPage3}/>
            </Col>
            
          </Row>
        </Container>
        </section>
        
      
    </div>
    );
}

export default About;
